import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { makeStyles } from "@material-ui/styles";
import CustomerForm from "./Form";
import { getInitialValues } from "./util";
import { AppContext, TOAST } from "../../context";
import { AccountContext } from "../accountContext";

const useStyles = makeStyles({
  updateManaged: {}
});

const UPDATE_MANAGED_SUBMIT = gql`
  mutation updateManagedSubmit($payload: UpdateManagedPartyMutation!) {
    updateManagedParty(payload: $payload) {
      isSuccess
      message
    }
  }
`;

const UpdateManaged = props => {
  const classes = useStyles();
  const language = useSelector(state => state.language);
  const accountContext = useContext(AccountContext);
  const { dispatch } = useContext(AppContext);
  const { activePerson } = accountContext.state;
  const handleMutationError = error => {
    dispatch({ type: TOAST, payload: { text: error, variant: "error" } });
  };
  const handleMutationSuccess = ({ updateManagedParty }) => {
    if (updateManagedParty.isSuccess) {
      return dispatch({
        type: TOAST,
        payload: {
          text: language.Toasts.customerInfoSubmitSuccess,
          variant: "success"
        }
      });
    }
    return dispatch({
      type: TOAST,
      payload: {
        text:
          language.Toasts[updateManagedParty.message] ||
          updateManagedParty.message,
        variant: "error"
      }
    });
  };
  const [update] = useMutation(UPDATE_MANAGED_SUBMIT, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess
  });
  const handleSubmit = (values, actions, toggleEdit) => {
    const newValues = { ...values, managedPartyId: activePerson.id };
    update({ variables: { payload: newValues } }).then(() => {
      actions.setSubmitting(false);
      return toggleEdit();
    });
  };
  return (
    <div className={classes.updateManaged}>
      <CustomerForm
        activePerson={activePerson}
        handleSubmit={(values, actions, toggleEdit) =>
          handleSubmit(values, actions, toggleEdit)
        }
        initialValues={getInitialValues(activePerson)}
        language={language}
      />
    </div>
  );
};

export default UpdateManaged;
